<div class="side d-flex flex-column flex-shrink-0 mt-5">
  <div
    type="button"
    class="row link-dark text-decoration-none p-3 d-flex justify-content-center"
  >
    <img
      src="https://store.toogoodtogo.com/static/3871b1e324e144758944.svg"
      alt="Logo Zero Waste"
      style="width: 80px"
    />
    <!-- <div class="col-9 hide-label">
      <H5 class="m-0">Mohamed Oussema Njimi</H5>
      <span class="font__small_italic">Administrateur fonctionel</span>
    </div> -->
  </div>
  <ul class="nav flex-column pt-4" id="menu">
    <span *ngFor="let item of sideMenu; index as i">
      <li
        tabindex="1"
        class="nav-item nav-link d-flex align-items-center"
        [routerLink]="item.link"
        routerLinkActive="active-link"
      >
        <span [class]="item.icon"></span>
        <span translate class="pe-3 hide-label">{{ item.libelle }}</span>
      </li>
    </span>
    <li
      class="nav-item nav-link d-flex align-items-center"
      routerLink="/logout"
      (click)="logout()"
    >
      <span class="icon icon-logout"></span>
      <span translate class="hide-label">MENU.LOGOUT</span>
    </li>
  </ul>
</div>
